/**
 * OR-74 BR-002 Configure Hub legacy route redirects.
 *
 * Maps the old top-level /admin/{component} routes onto the new tabbed
 * Configure Components page so existing bookmarks and external links keep
 * working. Detail/sub paths (e.g. /admin/microservices/:id) are left
 * untouched and matched by their dedicated routes.
 */

import { Navigate, Route } from 'react-router-dom'

interface Redirect {
  from: string
  to: string
}

const REDIRECTS: Redirect[] = [
  { from: 'admin/microservices', to: '/configure-hub/components?tab=microservices' },
  { from: 'admin/systems', to: '/configure-hub/components?tab=systems' },
  { from: 'admin/system-categories', to: '/configure-hub/components?tab=system-categories' },
  { from: 'admin/infrastructure', to: '/configure-hub/components?tab=infrastructure' },
  {
    from: 'admin/infrastructure-categories',
    to: '/configure-hub/components?tab=infrastructure-categories',
  },
  { from: 'admin/locations', to: '/configure-hub/components?tab=locations' },
  { from: 'admin/teams', to: '/configure-hub/components?tab=teams' },
  { from: 'admin/relationships', to: '/configure-hub/components?tab=relationships' },
  { from: 'admin/suppliers', to: '/configure-hub/components?tab=suppliers' },
  // /admin/bulk-upload retired — no per-tab landing; redirect to the page itself.
  { from: 'admin/bulk-upload', to: '/configure-hub/components' },
]

export function configureHubRedirects() {
  return REDIRECTS.map(({ from, to }) => (
    <Route key={from} path={from} element={<Navigate to={to} replace />} />
  ))
}
